import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from 'axios'
import Slider from "react-slick";
import './Events.scss';
import { ROOT_API_URL } from "../../../../../api-config";
import { auth } from '../../../../../services';
import { getMyMemberships } from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';

import EventsFilter from '../../../../PublicView/Pages/EndUser/Events/EventFilters';

class EventsHome extends Component {
    constructor(props) {
        super(props);

        this.state = {
            events: [],
            featuredEvents:[],
            UserId: null,
            RegionId: null,
            DistrictId: null,
            EventCategoryId: null,
            UserId: null,
            CountyID: 1
        }
    }

    componentDidMount() {
        var userId = auth.getAuthUserId();
        this.setState({
            UserId: userId
        });
        this.getEvents();
    }

    getEvents = () => {
        axios.post(`${ROOT_API_URL}/events/GetEvents`, {
            RegionId: this.state.RegionId,
            DistrictId: this.state.DistrictId,
            EventCategoryId: this.state.EventCategoryId,
            UserId: this.state.UserId,
            CountyID: this.state.CountyID
        })
            .then(res => {
                console.log(res, 'this is the result from the pulling evenbts')
                let e = res.data.filter(function (event) {
                    return event.isActive == true
                });
                this.setState({
                    events: e,
                    featuredEvents: e
                })
            });

    }

    updateEvents = (events) => {
        console.log(events);
        axios.post(`${ROOT_API_URL}/events/GetEvents`, events)
            .then(res => {
                this.setState({
                    events: res.data
                })
            });
    }

    rsvpClick = (event) => {
        console.log(event);
        axios.post(`${ROOT_API_URL}/events/SaveRsvp`, {EventId:event.eventID,
            AspNetUserId:this.state.UserId,
            Response:true})
            .then(res => {
                // this.setState({
                //     events: res.data
                // })
            });
    }

    formatDate = (date) => {
        let month = date.getMonth() + 1;
        month = month.toString().length != 2 ? '0' + month.toString(): month;
        let day = date.getDate();
        day = day.toString().length != 2 ? '0' + day.toString() : day;
        let year = 1900 + date.getYear();
        let minutes = date.getMinutes();
        minutes = minutes.toString().length != 2 ? '0' + minutes.toString() : minutes;
        let hour = "";       
        let suffix = "AM"
        if (date.getHours() >= 12) {
            hour = date.getHours() - 12;
            suffix = "PM";
            if (hour.toString().length != 2) {
                hour = '0' + hour;
            }
        }
        else if (date.getHours() == 0) {
            hour = 12;
        }
        else {
            hour = date.getHours();
            if (hour.toString().length != 2) {
                hour = '0' + hour;
            }
        }

        return month + "/" + day + "/" + year + " " + hour + ":" + minutes + " " + suffix;
    }

    eventUrl = (event) => {
        return event.imageURL !== null? event.imageURL : '/images/tempSliderImage.jpg'
    }

    displayEvent = (event, index) => {
        if (event.banner) {
            return (

                <div className="eventSingleSlider" key={index}>{console.log(event, "event obj")}
                    <div style={{
                            background: "url("+ this.eventUrl(event) +") no-repeat center #eee",
                            backgroundSize: "cover",
                            padding: "55px 15px"
                        }}>{/*we had to add a nested div because carousel was overwriting inline styling of the first outermost div*/}
                        <h3 className="eventSliderTitle">{event.title}</h3>
                        <p className="eventSliderLocation">{event.location}</p>
                    <p className="eventSliderAddress">{event.city} {event.stateName} {event.zip}</p>
                        <div className="sliderBtnContainer">
                            <a href={event.externalURL} target="_blank"><button className="eventSliderPrimaryBtn">{event.externalURLLabel}</button></a>
                            <Link to={`/eventdetails/${event.eventID}`}><button className="eventSliderSecondaryBtn">Event Info</button></Link>
                        </div>
                    </div>
                    
                </div>

            )
        }
        else {
            return "";
        }
    }

    render() {
        var settings = {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 10000,
            cssEase: "linear",
            pauseOnHover: true
        };

        return (
            <div className="eventsPage">
                <div className="eventsSlider">
                    <Slider {...settings}>
                        {this.state.events ? this.state.featuredEvents.map((event, index) => {
                            return this.displayEvent(event, index)
                        }) : ""}
                    </Slider>
                </div>
                <EventsFilter updateEvents={this.updateEvents} getEvents={this.getEvents} />
                <div className="eventsContainer">
                    <div className="container">
                        <h3>TSCRA Events</h3>
                        {
                            this.state.events.length !== 0 ?
                            <div className="eventsList row">
                            {this.state.events.map((event, index) => {
                                return (
                                    <div className="col-lg-6" key={index}>
                                        <div className="eventCard">
                                            <div className="wrapper">
                                                <div className="toprow">
                                                    <div className="col-md-6">
                                                        <h4 className="cardTitle">{event.title}</h4>
                                                        <p className="cardText">{event.description != null && event.description.length > 150 ? event.description.substring(0, 150) + '...' : event.description }</p>
                                                    </div>
                                                   
                                                    <div className="imgPic">
                                                        {
                                                            event.imageURL ? (<img alt="" src={event.imageURL} />) : ""
                                                        }
                                                        
                                                    </div>
                                                </div>
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <p className="cardLocation">{event.city ? event.city + ', ' : ''}{event.stateName}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="cardDate">Start - {this.formatDate(new Date(event.startDate))}<br /> End - {this.formatDate(new Date(event.endDate))}<br />(Local Time)</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="push"></div>
                                            </div>
                                            
                                            <div className="footer">
                                                <div className="button-container">
                                                    {/* RSVP was added as button text below..not sure we want to keep it static or make it dynamic? */}
                                                    {event.externalURL ? <a href={event.externalURL} target="_blank"><button className="cardPrimaryBtn">{event.externalURLLabel}</button></a> : ""}
                                                    <Link to={`/eventdetails/${event.eventID}`}><button className="cardSecondaryBtn">Event Info</button></Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>    
                                )
                            })}
                        </div> : <div className="noEvents">No Events Available, Check Back Later.</div> 
                        }
                       
                    </div>
                </div>
            </div>
        );
    }
}

//function mapStateToProps(state) {
//    return {
//        authentication: state.authentication,
//        common: state.common
//    }
//}

export default connect(null, { getMyMemberships })(EventsHome);